module.exports = __webpack_public_path__ + "static/media/icon-circle-dark-full.133c8f30.svg";